export default {
    title: `<i class="fa fa-cubes"></i> 연습 : 마크다운으로 스터디 모집 공고 만들기`,
    datas: [
        { type: "text",
            content: "지금까지 알아본 마크 다운 문법을 사용해서 간단한 스터디 모집 공고 문서를 만들어 보는 연습을 해봅니다."
        },
        { type: "link",
            content: "연습 문서 : 스터디 모집 공고 마크다운 문서",
            url: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/exercise/study-wanted.md"
        },

        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 연습할 문서`
        },
        { type: "text",
            content: "우선 우리가 만들어볼 문서의 결과 화면은 아래와 같습니다."
        },
        { type: "img",
            content: "/img/ex01.png" 
        },
        { type: "text",
            content: "주황색 글씨가 적용해야할 마크다운의 문법입니다. 텍스트는 아래의 내용을 복사하여 작성을 시작합니다."
        },
        { type: "text",
            content: `<small style="color:blue;">참고 : <code>&lt;!--</code>와 <code>--></code>로 둘러 쌓인 부분은 마크다운 및 HTML의 주석(결과 화면에 표시되지 않는 부분)입니다.</small>`
        },
        { type: "code2", code: "md", drag: true,
            content:
`<!-- 제목1 -->
Markdown 스터디 모집 공고

<!-- 이미지 삽입 -->
마크다운 로고 https://raw.githubusercontent.com/denlyou/sblabs_markdown_codelab_examples/master/mdlogo.png

<!-- 제목2 -->
소개

<!-- 구문 강조 -->
안녕하세요. Incheon Dev's에서 마크다운 코드랩 스터디원을 모집합니다.
<!-- 인용구 -->
마크다운(markdown)은 일반 텍스트 문서의 양식을 편집하는 문법이다. README 파일이나 온라인 문서, 혹은 일반 텍스트 편집기로 문서 양식을 편집할 때 쓰인다. 마크다운을 이용해 작성된 문서는 쉽게 HTML 등 다른 문서형태로 변환이 가능하다.
출처 : 위키백과

<!-- 제목3 -->
스터디 내용
<!-- 순서가 있는 목록 -->
텍스트 꾸미기
제목, 수평선, 인용구
링크와 이미지
목록과 체크박스
코드, 프로그래밍 언어 문법 강조
이모지와 뱃지
기타 등등

<!-- 제목2 -->
상세 모집 안내
<!-- 순서가 없는 목록 -->
시간 및 장소 : 2019.11.17(일) 인천의 어느 까페
준비물 : 실습용 노트북 지참
모집인원 : 10명 내외
참가비 : 약 5,000원 (개인 음료비)

<!-- 제목2 -->
문의 및 연락처
<!-- 링크 걸기 -->
홈페이지 : https://incheon.devs.co.kr  
전자메일 : incheon.devs@gmail.com  
또는 카카오톡 오픈채팅방 http://chat.devs.co.kr`
        },
        { type: "text",
            content: `위 텍스트 문서를 마크다운 문법을 적용하여 위 문서처럼 만들어보고 아래의 결과예제와 비교해 봅니다.`
        },
        { type: "link",
            content: "연습 문서 : 스터디 모집 공고 마크다운 문서 (소스)",
            url: "https://raw.githubusercontent.com/denlyou/sblabs_markdown_codelab_examples/master/exercise/study-wanted.md"
        },


        
       

        
        { type: "next",
            content: "다음",
            url: "/sections/05"
        },
    ]
}